/**
 * Created by Ivan on 24.02.2026
 */

Mission.TYPE_ISLAND_DECORATION = 93;

Mission.REGISTRATIONS.set(Mission.TYPE_ISLAND_DECORATION, () => ({
    available: cleverapps.config.availables.ISLAND_DECORATION_MISSION,
    canStart: function () {
        const period = IslandDecorationConfig.getPeriod();
        return period && bundles[`island_decoration_items_${period}`];
    },
    eventName: "islanddecoration",
    logic: IslandDecorationLogic,
    view: IslandDecorationWindow,
    startWindow: IslandDecorationStartWindow,
    tutorialScenario: IslandDecorationTutorial.NAME,
    stagesConfig: IslandDecorationConfig,
    semaphore: Mission.SEMAPHORE_ALWAYS,
    tillTheTimeEnds: true,
    oncePerEvent: true,
    feature: "island_decoration",
    name: "IslandDecoration",
    collectIcon: function () {
        const mission = IslandDecorationLogic.findRunningMission();
        const period = (mission && mission.logic.period) || IslandDecorationConfig.getPeriod();
        return bundles.reward_icons.frames[`island_decoration_start_${period}`];
    },
    sideBarJson: function (icon) {
        return bundles.sidebar.jsons[`island_decoration_icon_${icon.mission.logic.period}_json`];
    },
    reward: RewardsConfig.IslandDecorationReward,
    islandDecoration: { code: "islanddecoration", stage: 0 }
}));

cleverapps.InitByFeature["island_decoration"] = function () {
    cleverapps.tutorial.register(IslandDecorationTutorial());
};
